import EnlilAxios from "../../../../util/EnlilAxios";
import {V1DeveloperSubscriptionCommunicationIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";
import {v4 as uuidv4} from "uuid";


class DeveloperSubscriptionCommunicationEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let qbe = btoa(JSON.stringify({
            "ShifamedMessage": {
                "-idoc": "v1.DeveloperSubscription-002",
                "-id": uuidv4(),
                "DeveloperSubscription": {
                    "_attributes": {
                        "limit": 1,
                        "sort": null,
                        "offset": 0
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "QG1",
                                "Type": "QueryGroup",
                                "Operator": "AND",
                                "Membership": {
                                    "Member": [
                                        {
                                            "Type": "Attribute",
                                            "Name": "USID",
                                            "Value": foreignKey,
                                            "Operator": "EQUAL"
                                        }
                                    ]
                                }
                            }
                        ]
                    },
                    "DeveloperSubscriptionCommunication": {
                        "_attributes": {
                            "limit": 40,
                            "sort": "CreatedDatetime:DESC",
                            "offset": (page - 1) * pageSize
                        }
                    }
                }
            }
        }))

        EnlilAxios({
            method: "GET",
            url: "t2/v1/developer_subscriptions",
            json: true,
            params: {
                "QBE": qbe
            },
            headers: {
                "idoc-response": this.getIDOCResponse() ?? "v1.DeveloperSubscription-002",
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1DeveloperSubscriptionCommunicationIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

}

export default DeveloperSubscriptionCommunicationEnterpriseComponent;